export const OVERVIEW_DUMMY_DATA = [
  {
    avatarUrl: "/img/widgets/people/person-male-9.png",
    name: "Daniel Kim",
    subtitle: "Jun 13",
    label: "Today",
    emoji: "🎉",
  },
  {
    avatarUrl: "/img/widgets/people/person-female-4.png",
    name: "Sofia Rodríguez",
    subtitle: "Jun 23",
    label: "10 days",
  },
];
